import { render, staticRenderFns } from "./nav-dropdown-anchor.vue?vue&type=template&id=82b2420a&"
import script from "./nav-dropdown-anchor.vue?vue&type=script&lang=js&"
export * from "./nav-dropdown-anchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports